const getRequiredCheckboxPattern = () => {
  return {
    validate: (value) => (value == null ? "Please select an option" : true),
  };
};

export default getRequiredCheckboxPattern;
